import { render } from "./staffDialog.vue?vue&type=template&id=00e001fa"
import script from "./staffDialog.vue?vue&type=script&lang=js"
export * from "./staffDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__